module.exports = __webpack_public_path__ + "static/ceramics-early-works-thumbnail-8e7096bce02f33566888ac3851ed0885.jpg";